<template>
    <v-list-group
        color="neutral-1"
        no-action
        sub-group
    >
        <template v-slot:activator>
            <v-list-item-title v-text="menu.name"></v-list-item-title>

            <v-list-item-icon>
                <v-icon
                    v-if="menu.icon"
                    v-text="menu.icon"
                />
            </v-list-item-icon>
        </template>

        <template v-for="(child, id) in menu.children" >
            <category-menu-child v-if="child.children" :menu="child" :key="menu.name + id" />
            <category-menu-item v-else :menu="child" :space="3" :key="menu.name + id" />
        </template>
    </v-list-group>
</template>

<script>
import CategoryMenuChild from './CategoryMenuChild';
import CategoryMenuItem from './CategoryMenuItem';

export default {
    components: {
        CategoryMenuChild,
        CategoryMenuItem,
    },
    props: {
        menu: {
            required: true,
            type: Object,
        },
    },
};
</script>

<style scoped lang="scss">
.v-list-item, .v-icon {
    .v-list-item__title {
        font-weight: 400;
    }
}
</style>
